import Export1CRequest from "../../libs/core-api-requests/service/export1CRequest";
import { IExport1CProcedureCodeDto, IExport1CUpdateProcedureCodeDto } from "../../libs/coreapi-dto/service/export1C";
import CoreApiService from "../../system/api/coreApiService";
import { ServiceDataProvider } from "./Common";

export class Export1CProcedureDataProvider extends ServiceDataProvider<unknown, unknown> {
    private _coreApiService: CoreApiService;

    constructor(coreApiService: CoreApiService) {
        super();
        this._coreApiService = coreApiService;
    }

    getDataRequest(): Promise<Export1CRequest> {
        return this._coreApiService.export1CRequest;
    }

    getProcedureCode(callback?: (code: string) => void) {
        this.getDataRequest().then((r) =>
            r.getProcedureCode((e) => {
                if (e.respType === "isCompleted") {
                    callback?.(e.data.body);
                } else {
                    throw new Error(e.message.title ?? "Export1CProcedureDataProvider getProcedureCode !isCompleted");
                }
            })
        );
    }

    updateProcedureCode(code: string, callback?: () => void, fallback?: () => void) {
        const body: IExport1CUpdateProcedureCodeDto = { body: code, version: "" };
        this.getDataRequest().then((r) =>
            r.updateProcedureCode(body, (e) => {
                if (e.respType === "isCompleted") {
                    callback?.();
                } else {
                    if (fallback) {
                        fallback();
                    } else {
                        throw new Error(e.message.title ?? "Export1CProcedureDataProvider updateProcedureCode !isCompleted");
                    }
                }
            })
        );
    }
}
